/**
 * Single source of truth for all limits and thresholds for the product recommendations
 * (suggestive selling / "Frequently bought together") feature.
 *
 * Used by: server (get-recommendations route), client (SelectedProductsList, useRecommendations,
 * request helper). OpenAPI get-recommendations.yaml documents the API default; keep its
 * limit default in sync with RECOMMENDATIONS_DEFAULT_LIMIT here.
 */

// --- API (server + client when calling API) ---

/** Default max number of recommendation IDs returned when client omits limit. */
export const RECOMMENDATIONS_DEFAULT_LIMIT = 20;

/** Server-side cap: validation rejects limit above this. */
export const RECOMMENDATIONS_MAX_LIMIT = 100;

/** Validation: limit query param must be >= this. */
export const RECOMMENDATIONS_MIN_LIMIT = 1;

// --- Client-only (when to show section + refetch behavior) ---

/** Maximum number of suggested items to show in the "Frequently bought together" UI. */
export const RECOMMENDATIONS_DISPLAY_LIMIT = 3;

/** Minimum number of items in cart before showing the suggestions section. */
export const RECOMMENDATIONS_MIN_ITEMS = 1;

/** Minimum cart value (dollars) when showPricing is true before showing suggestions. */
export const RECOMMENDATIONS_MIN_CART_VALUE = 0.00;

/** TanStack Query staleTime (ms); avoids refetch on every small cart change. */
export const RECOMMENDATIONS_STALE_TIME_MS = 60 * 1000; // 1 minute
